// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';

@Component({
    selector: 'violation-modules',
    standalone: false,
    template: `
        <div class="card panel-monsido-card violation-modules" *ngIf="showSpelling || showDeadlinks">
            <mon-panel-header [pHeader]="'Quality Assurance Check' | translate"></mon-panel-header>
            <div class="card-body">
                <mon-spinner [progress]="progress">
                    <div class="row align-items-stretch" *ngIf="qaSummary">
                        <div class="col-48 col-md-24" *ngIf="showDeadlinks">
                            <notification
                                    [link]="'base.customer.domain.qa.broken.links'"
                                    [faIcon]="'fas fa-unlink fa-3x'"
                                    [title]="'Unique broken links' | translate"
                                    [digit]="qaSummary.broken_links"
                                    [monAriaButtonText]="'Go to broken links' | translate"
                                    [monAriaIconText]="'Broken links' | translate"
                                    [classColor]="'text-link'">
                                {{ 'Affects' | translate }} {{ qaSummary.pages_with_broken_links | monNumber }} {{ 'pages' | translate }}
                                <span *ngIf="qaSummary.documents_with_broken_links > 0"
                                      translate
                                      [translate-args]="{$count: qaSummary.documents_with_broken_links}"
                                      translate-context="Pages with broken links"
                                      [translate-n]="qaSummary.documents_with_broken_links"
                                      translate-plural="and [[$count]] documents"
                                > and one document
                                </span>
                            </notification>
                            <span class="vertical-ruler vertical-ruler-right vertical-ruler-1 d-xs-none d-sm-none d-md-block"></span>
                        </div>
                        <div class="col-48 col-md-24" *ngIf="showSpelling">
                            <notification
                                    tabindex="0"
                                    [link]="'base.customer.domain.qa.spellcheck.potential'"
                                    [faIcon]="'fas fa-language fa-3x'"
                                    [title]="'Potential misspellings' | translate"
                                    [digit]="qaSummary.potential_misspellings"
                                    [monAriaButtonText]="'Go to potential misspellings' | translate"
                                    [monAriaIconText]="'Potential misspellings' | translate"
                                    [classColor]="'text-link'">
                                {{ 'Affects' | translate }} {{ qaSummary.pages_with_potential_misspellings | monNumber }} {{ 'pages' | translate }}
                                <span *ngIf="qaSummary.documents_with_potential_misspellings > 0"
                                          translate
                                          [translate-args]="{count: qaSummary.documents_with_potential_misspellings}"
                                          translate-context="Documents with potential misspellings"
                                          [translate-n]="qaSummary.documents_with_potential_misspellings | monNumber"
                                          translate-plural="and [[count]] documents">
                                     and 1 document
                                </span>
                            </notification>
                        </div>
                        <div class="col-48 col-md-24" *ngIf="showDeadlinks">
                            <notification
                                    [link]="'base.customer.domain.qa.broken.images'"
                                    [faIcon]="((['LINKS', 'IMAGE'] | monIcons) + ' fa-3x')"
                                    [title]="'Broken images' | translate"
                                    [digit]="qaSummary.broken_images"
                                    [monAriaButtonText]="'Go to broken images' | translate"
                                    [monAriaIconText]="'Broken images' | translate"
                                    [classColor]="'text-link'">
                                {{ 'Affects' | translate }} {{ qaSummary.pages_with_broken_images | monNumber }} {{ 'pages' | translate }}
                                <span *ngIf="qaSummary.documents_with_broken_images > 0"
                                      translate
                                      [translate-args]="{count: qaSummary.documents_with_broken_images}"
                                      translate-context="Documents with broken images"
                                      [translate-n]="qaSummary.documents_with_broken_images | monNumber"
                                      translate-plural=" and [[count]] documents"
                                > and 1 document</span>
                            </notification>
                            <span class="vertical-ruler vertical-ruler-right vertical-ruler-1 d-xs-none d-sm-none d-md-block"></span>
                        </div>
                        <div class="col-48 col-md-24" *ngIf="showSpelling">
                            <notification
                                    tabindex="0"
                                    [link]="'base.customer.domain.qa.spellcheck.confirmed'"
                                    [faIcon]="'fas fa-language fa-3x'"
                                    [title]="'Misspellings' | translate"
                                    [digit]="qaSummary.confirmed_misspellings"
                                    [monAriaButtonText]="'Go to misspellings' | translate"
                                    [monAriaIconText]="'Misspellings' | translate"
                                    [classColor]="'text-link'">
                                {{ 'Affects' | translate }} {{ qaSummary.pages_with_confirmed_misspellings | monNumber }} {{ 'pages' | translate }}
                                <span *ngIf="qaSummary.documents_with_confirmed_misspellings > 0"
                                      translate
                                      [translate-args]="{count: qaSummary.documents_with_confirmed_misspellings}"
                                      translate-context="Documents with confirmed misspellings"
                                      [translate-n]="qaSummary.documents_with_confirmed_misspellings | monNumber"
                                      translate-plural="and [[count]] documents">
                                and 1 document
                                </span>
                            </notification>
                        </div>
                    </div>
                </mon-spinner>
            </div>
        </div>
    `,
})
export class ViolationModulesComponent implements OnInit {
    @Input() qaSummary: any;
    @Input() progress: any;

    showDeadlinks: boolean = false;
    showSpelling: boolean = false;

    constructor (private activeFeatureService: ActiveFeatureService) {
    }

    ngOnInit (): void {
        this.showDeadlinks = this.activeFeatureService.isFeatureActivePure('qa_links');
        this.showSpelling = this.activeFeatureService.isFeatureActivePure('qa_spellcheck');
    }
}
